import ScrollView from './ScrollView';

ScrollView.install = function(Vue) {
    Vue.component(ScrollView.name, ScrollView);
};

export default ScrollView;